module.exports = __webpack_public_path__ + "bc8d096969837e6a1f86eea09078806e.pdf";